import styles from './RateCardStepper.module.scss';
import { Timeline } from '@components/CORE';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';

type TProps = {
	activeIndex: number;
}

export const RateCardStepper = (props: TProps) => {
	const steps = [
		'Rate Card Details',
		'Carrier Rate Card',
		'Shipper Rate Card'
	];
	const { activeIndex } = props;
	return <>
		<div className={styles.stepper}>
			<div style={{ width: '100%' }}>
				<Timeline dir={'horizontal'}>
					{steps.map((step, index) => {
						if (activeIndex > index) {
							return <Timeline.Item key={step} date={step} icon={<CheckOutlinedIcon style={{ color: 'white' }} />} backgroundColor={'#F05637'} />;
						}
						if (activeIndex === index) {
							return <Timeline.Item key={step} date={step} dateColor='#F05637' icon={<span style={{ color: 'white' }}>{index + 1}</span>} backgroundColor={'#F05637'}/>;
						}

						return <Timeline.Item key={step} date={step} icon={<>{index + 1}</>} />;
					})}

				</Timeline>
			</div>
		</div>
	</>
}